/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { LEFT_QUOTE, RIGHT_QUOTE } from '../../../../config';

import './TopInfo.scss';

interface TopInfoProps {
    title: string | undefined;
    episodeTitle: string | undefined;
    episodeNumber: number | undefined;
    episodeSeason: number | undefined;
    isMovie: boolean;
    movieYear?: string | number;
    hideMetadata: boolean;
}
const TopInfo = ({
    title,
    episodeTitle,
    episodeNumber,
    episodeSeason,
    isMovie,
    movieYear,
    hideMetadata,
}: TopInfoProps) => {
    const season = episodeSeason ? `S${episodeSeason}` : '';
    const episode = episodeNumber ? `E${episodeNumber}` : '';
    const seaEp = `${season} ${episode}`.trim();

    if (hideMetadata) {
        return null;
    }

    let subtitle: JSX.Element | null = null;
    if (seaEp) {
        subtitle = (
            <span>
                {seaEp} {LEFT_QUOTE}
                {episodeTitle}
                {RIGHT_QUOTE}
            </span>
        );
    } else if (episodeTitle) {
        subtitle = (
            <span>
                {LEFT_QUOTE}
                {episodeTitle}
                {RIGHT_QUOTE}
            </span>
        );
    }

    return (
        <div>
            <div className="top-info-title" data-testid="preview-title-subtitle">
                {title && <span className="title-text">{title}</span>}
                {isMovie && movieYear && <span className="movie-year"> ({movieYear})</span>}
            </div>
            <div className="top-info-subtitle">{subtitle}</div>
        </div>
    );
};

export default TopInfo;
